import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    currentPage:1
}
const agentUserListReducer = createSlice({
    name:'agentUserMethodsReducer',
    initialState,
    reducers:{
        setCurrentPage(state,action) { // 修改页数
            state.currentPage = action.payload
        }
    }
})

export const { setCurrentPage } = agentUserListReducer.actions

export default agentUserListReducer.reducer